import {Navigate, Route, Routes} from 'react-router-dom';
import styled from 'styled-components';

import AdobeTargetProvider from 'components/app/AdobeTargetProvider';
import {Flex} from 'components/base/Flex';
import {getRoute} from 'config/navigation';
import {PrototypeMode, StaticConfig} from 'config/staticConfig';
import ChatBot from 'features/ChatBot/components';
import {useImagePreloader} from 'hooks/loaders/ImageLoader';
import OutdatedBrowserBanner from 'shared/components/GlobalBanners/OutdatedBrowserBanner';
import {useUserConnectionLogger} from 'shared/Ensighten/hooks';
import ErrorBoundary from 'shared/Errors/components/ErrorBoundary';
import PageHelmet from 'shared/PageHelmet/components';
import {Breakpoints} from 'styles/Base';
import 'axiosResponseInterceptor';
import Loadable, {Suspense} from 'utils/Loadable';

const AppWrapper = styled(Flex)`
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
`;

const AsyncAppPages = Loadable({loader: () => import('components/app/App/AppPages')});
const AsyncQuotingPages = Loadable({loader: () => import('components/quoting/Pages')});

const App = () => {
  useUserConnectionLogger();
  useImagePreloader('/customers/static/media/login-background-image.webp', '/login', Breakpoints.DESKTOP);

  return (
    <>
      {!StaticConfig.mobileApplicationMode && StaticConfig.prototypeMode === PrototypeMode.NONE && (
        <OutdatedBrowserBanner />
      )}
      <AdobeTargetProvider>
        <AppWrapper>
          <PageHelmet />
          <ErrorBoundary>
            {StaticConfig.prototypeMode === PrototypeMode.NONE && (
              <>
                {!StaticConfig.mobileApplicationMode && StaticConfig.chatBotDeploymentID && <ChatBot />}
                <Suspense>
                  <Routes>
                    <Route path={getRoute('/quoting').concat('/*')} element={<AsyncQuotingPages />} />
                    <Route path="/*" element={<AsyncAppPages />} />
                  </Routes>
                </Suspense>
              </>
            )}
            {StaticConfig.prototypeMode === PrototypeMode.QUOTING && (
              <Suspense>
                <Routes>
                  <Route path={getRoute('/quoting').concat('/*')} element={<AsyncQuotingPages />} />
                  <Route index path="*" element={<Navigate to={getRoute('/quoting')} />} />
                </Routes>
              </Suspense>
            )}
          </ErrorBoundary>
        </AppWrapper>
      </AdobeTargetProvider>
    </>
  );
};

export default App;
